import { BaseGameState } from "@quest/murka-games-behavior-panther/dist/Game/State/BaseGameState";
import { CascadingReelPanelController } from "../Base/CascadingReelPanelController";
import { BaseView, dispatcher, ingenuity } from "@quest/base-core";
import { CascadingReelPanelView } from "../Base/CascadingReelPanelView";
import { BaseGameProgressBar } from "../Base/BaseGameProgressBar";
import { BaseGameViewGame } from "../Base/BaseGameViewGame";
import { ClusterWinFrameView } from "../ClusterWinFrame/ClusterWinFrameView";
import { ClusterWinFrameController } from "../ClusterWinFrame/ClusterWinFrameController";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { QLinePlayerMsgController } from "../Base/QLinePlayerMsgController";
import { revealSymbolControllerBG } from "../Base/revealSymbolControllerBG";
import { FishingTimeHoldAndRespinLogic } from "../FishingTimeHoldAndRespin/Logic/FishingTimeHoldAndRespinLogic";
import { CollectionScreenController } from "../Collection/CollectionScreenController";
import { CollectionScreenView } from "../Collection/CollectionScreenView";
import { CollectionBannerController } from "../Collection/CollectionBannerController";
import { SlotEventConstantsBehavior } from "@quest/murka-games-behavior-panther";
import { CollectionModel } from "../Collection/CollectionModel";
import { CollectionBannerView } from "../Collection/CollectionBannerView";

export class BaseGameStateGame extends BaseGameState {
  private cascadeView: BaseView;
  protected view: BaseGameViewGame;
  protected clusterWinFrameView: ClusterWinFrameView;
  protected clusterWinFrameController: ClusterWinFrameController;
  private fishingTimeRespinLogic: FishingTimeHoldAndRespinLogic;
  private collectionView: CollectionScreenView;
  private collectionBannerView: CollectionBannerView;



  // Overrided to Initialize some features and to fire events
  public init(): void {
    super.init();
    this.initializeCascadingReelPanelController();
    this.initializeBaseGameProgressBar();
    this.initializeQlinePlayerMsg();
    this.initializeRevealSymbolController();
  }

  // Overrided to subscribe events
  protected subscribeEventsGame(): void {
    super.subscribeEventsGame();
    dispatcher.on(eventDispatchers.INITIALIZE_CLUSTER_WIN_FRAME, this.initializeClusterWinFrame, this);
    dispatcher.on(eventDispatchers.INITIALIZE_RESPIN_FEATURE, this.initializeRespin, this);
    dispatcher.on(eventDispatchers.INITIALIZE_COLLECTION_SCREEN, this.initializeCollection, this);
    dispatcher.on(eventDispatchers.DESTROY_RESPIN, this.resetRespinFeature, this)

  }

  // Overrided to un-subscribe events
  protected unSubscribeEvents(): void {
    super.unSubscribeEvents();
    dispatcher.off(eventDispatchers.INITIALIZE_CLUSTER_WIN_FRAME, this.initializeClusterWinFrame, this);
    dispatcher.off(eventDispatchers.INITIALIZE_RESPIN_FEATURE, this.initializeRespin, this);
    dispatcher.off(eventDispatchers.INITIALIZE_COLLECTION_SCREEN, this.initializeCollection, this);
    dispatcher.off(eventDispatchers.DESTROY_RESPIN, this.resetRespinFeature, this)

  }
  /**
   * To initialized cascade reel view and controller
   */
  private initializeCascadingReelPanelController(): void {
    this.cascadeView = new CascadingReelPanelView(ingenuity.currentGame.cache.getJSON("main_data").cascadingReelPanel);
    this.view.addChild(this.cascadeView);
    new CascadingReelPanelController(this.view, this.cascadeView, this.model);
  }
  private initializeBaseGameProgressBar(): void {
    new BaseGameProgressBar(this.view);
  }

  // To initialize cluster win frame
  protected initializeClusterWinFrame(): void {
    if (!this.clusterWinFrameView) {
      this.clusterWinFrameView = new ClusterWinFrameView(
        ingenuity.currentGame.cache.getJSON("main_data").ClusterWinFrame
      );
      this.clusterWinFrameController = new ClusterWinFrameController(this.clusterWinFrameView, this.view);
      this.winReelpanel.addChildAt(this.clusterWinFrameView, this.winReelpanel.children.length);
    }
  }

  //To initialize Q lIne Player Message

  protected initializeQlinePlayerMsg(): void {
    new QLinePlayerMsgController(this.view);
  }
  //initialize reveal symvol controller
  protected initializeRevealSymbolController(): void {
    new revealSymbolControllerBG(this.view);
  }
  /**
   * to initialize respin logic
   */
  private initializeRespin(): void {
    if (!this.fishingTimeRespinLogic) {
      this.fishingTimeRespinLogic = new FishingTimeHoldAndRespinLogic();
    }
  }

  /**
   * to initialize CollectionScreen Screen
   */

  private initializeCollection(): void {
    if (!this.collectionView && !this.collectionBannerView) {
      this.collectionView = new CollectionScreenView(ingenuity.currentGame.cache.getJSON("main_data").collectionScreen);
      this.collectionBannerView = new CollectionBannerView(ingenuity.currentGame.cache.getJSON("main_data").collectionBanner);
      const collectionModel = new CollectionModel();
      new CollectionScreenController(this.collectionView, collectionModel);
      new CollectionBannerController(this.collectionBannerView, collectionModel);
      ingenuity.currentGame.stage.addChild(this.collectionView);
      ingenuity.currentGame.stage.addChild(this.collectionBannerView);
      dispatcher.fireEvent(SlotEventConstantsBehavior.ADD_BUTTON_PANEL_ON_TOP);
    }

  }
  //to create mask on win
  protected initializeWinReelPresentation(): void {
    super.initializeWinReelPresentation();
    dispatcher.fireEvent(eventDispatchers.CREATE_WIN_MASK);
  }

  // to reset respin
  private resetRespinFeature(): void {
    this.fishingTimeRespinLogic = null;
  }
}
